import { useEffect } from "react";
import { WindowAPI } from "@contentful/app-sdk";

export const useAutoResizer = (window: WindowAPI): void => {
  useEffect(() => {
    window.startAutoResizer({absoluteElements:true});
    return window.stopAutoResizer;
  }, [window]);
};
